import { Card, css, Space, styled } from 'canoe';
import React, { ReactNode } from 'react';

const StyledCard = styled(Card)<{
  isActive?: boolean;
  isHoverable?: boolean;
  horizontalSpace: 'xs' | 'xxs';
}>`
  ${({ theme, isActive, isHoverable, horizontalSpace }) => css`
    padding-left: ${theme.spaces[horizontalSpace]};
    border-radius: ${theme.borderRadius.small};
    border: 1px solid ${theme.colors.GlitterGray};
    display: flex;
    align-items: center;

    ${isHoverable &&
    css`
      &:hover {
        background-color: ${theme.colors.GlitterGrayL30};
      }
    `}

    ${isActive &&
    css`
      border-color: ${theme.colors.BrandPurple};
    `}
  `}
`;

export interface ValueCardProps {
  children: ReactNode;
  padding?: Space;
  onClick?: () => void;
  isActive?: boolean;
  isHoverable?: boolean;
  horizontalSpace?: 'xs' | 'xxs';
  className?: string;
}

export const ValueCard = React.forwardRef<HTMLDivElement>(
  (
    {
      children,
      padding,
      onClick,
      isActive,
      isHoverable,
      horizontalSpace = 'xs',
      className,
    }: ValueCardProps,
    ref,
  ) => {
    return (
      <StyledCard
        padding={padding}
        ref={ref}
        onClick={onClick}
        className={className}
        isActive={isActive}
        isHoverable={isHoverable}
        horizontalSpace={horizontalSpace}
      >
        {children}
      </StyledCard>
    );
  },
);
